import AsyncRecorder from './AsyncRecorder';
import RecordType from '../data/RecordType';
import { RecorderEvent } from './Recorder';

const GIF = (window as any).GIF;

export default class extends AsyncRecorder {
  width: number;
  height: number;
  isScaled: boolean;
  scaledCanvas: HTMLCanvasElement;
  scaledContext: CanvasRenderingContext2D;
  gif: any;
  duration: number;
  type = RecordType.GIF;

  private _delay: number;
  constructor(
    canvas: HTMLCanvasElement,
    width: number,
    height: number,
    framesNumber: number,
    duration: number,
    transparent: boolean = false
  ) {
    super(canvas, framesNumber, duration, null, null);

    this.width = width;
    this.height = height;
    this.framesNumber = framesNumber;
    this.duration = duration;

    this._delay = duration / (this.framesNumber - 1);

    this.isScaled = canvas.width !== width || canvas.height !== height;
    if (this.isScaled) {
      this.scaledCanvas = document.createElement('canvas');
      this.scaledCanvas.width = width;
      this.scaledCanvas.height = height;
      this.scaledContext = this.scaledCanvas.getContext('2d')!;
      // this.scaledContext.imageSmoothingQuality = "medium"
    }

    this.gif = new GIF({
      workers: 4,
      quality: 10,
      width,
      height,
      workerScript: '/js/gif.worker.js',
      // dither: 'Atkinson',
      // transparent: 0x00000000,
      transparent: transparent ? 0x00000000 : undefined,
      debug: true
    });
    this.gif.on('finished', this.renderDidFinish);
  }

  getCurrentTime(): number {
    return this.duration * this.getPosition();
  }

  update() {
    if (!this.gif) {
      return;
    }
    if (this._currentFrame === this.framesNumber) {
      return;
    }
    let origin: HTMLCanvasElement | CanvasRenderingContext2D;
    origin = this.canvas;
    if (this.isScaled) {
      this.scaledContext.drawImage(origin, 0, 0, this.width, this.height);
      origin = this.scaledContext;
    }
    this.gif.addFrame(origin, { copy: true, delay: this._delay });
    this._currentFrame++;
    if (this._currentFrame === this.framesNumber) {
      this.emit(RecorderEvent.RecordingEnded);
      this.gif.render();
    }
  }

  renderDidFinish = (blob: Blob) => {
    console.log('recorded: ' + (blob.size / 1000).toFixed(2) + 'kb');
    this.gif = null;
    this.emit(RecorderEvent.Complete, URL.createObjectURL(blob));
  };

  // recording happens so fast that we assume there is no time to cancel the operation.
  cancel() {
    this.gif = null;
    // if (wi) {
    //   wi.clearTemporaryFolder();
    // }
  }
}



// WEBPACK FOOTER //
// ./src/video/GIFRecorder.ts